import { List } from "react-native-paper";
import { useAppTheme } from "../useAppTheme";

type Props = {
	showHint: boolean;
	title: React.ReactNode;
	handleToggle: () => void;
	isLastHint?: boolean;
};
const HintAccordionListItem = ({
	showHint,
	title,
	handleToggle,
	isLastHint,
}: Props) => {
	const theme = useAppTheme();
	const leftIcon = showHint ? "lightbulb-on-outline" : "lightbulb-outline";
	const color = showHint
		? theme.colors.onPrimaryContainer
		: theme.colors.primary;
	return (
		<List.Item
			left={(props) => (
				<List.Icon
					{...props}
					icon={leftIcon}
					color={color}
					style={[
						props.style,
						{
							alignSelf: "flex-start",
						},
					]}
				/>
			)}
			style={{
				...(showHint
					? {
							backgroundColor: theme.colors.secondaryContainer,
							cursor: "auto",
							...(isLastHint ? { paddingRight: 4 } : {}),
						}
					: {}),
			}}
			title={() => title}
			onPress={showHint ? undefined : handleToggle}
		/>
	);
};

export default HintAccordionListItem;
